import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { Modal, Table, Icon, Loader, Button } from 'react-inv-forms';

import AdditionalInformation from './AdditionalInformation';

import { closeCopyFinalMarksModal } from '../../../redux/appConfig/actions';
import { getCopyFinalMarksModalData } from '../../../redux/appConfig/selectors';
import { copyFinalMarks } from '../../../redux/dynamicTabs/stronaPrzedmiotu/actions';

import TableCellTypes from '../../../helpers/tableCellTypes';
import columns from './columns';

import penRed from '../../../images/penRed.svg';

/**
 * Komponent modala wystawiania ocen końcowych na podstawie oceny wyliczonej
 */
const CopyFinalMarksModal = (): JSX.Element => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { loading, error, opened, studentData } = useSelector(getCopyFinalMarksModalData);

  const closeModal = () => dispatch(closeCopyFinalMarksModal());

  const modalFooter = [
    <Button key='cancel' onClick={closeModal}>
      {t(error.isError ? 'CLOSE' : 'CANCEL')}
    </Button>,
    <Button
      key='confirm'
      type='primary'
      loading={loading}
      onClick={() => dispatch(copyFinalMarks(studentData))}
      hidden={error.isError}
    >
      {t('CONFIRM')}
    </Button>,
  ];

  return (
    <Modal
      title={
        <span>
          <Icon path={penRed} />
          {t('COPY_FINAL_MARKS_MODAL_TITLE')}
        </span>
      }
      footer={modalFooter}
      visible={opened}
      confirmLoading={loading}
      onCancel={closeModal}
      maskClosable={false}
      width='90%'
      className='cyCopyFinalMarksModal'
    >
      <AdditionalInformation />
      <Table
        rowKey='studentAlbum'
        dataSource={TableCellTypes.generateTableContent(studentData, columns)}
        columns={columns}
        loading={{
          spinning: loading,
          indicator: <Loader style={{ fontSize: '24px' }} />,
        }}
        pagination={false}
        scroll={{ x: 'max-content' }}
      />
    </Modal>
  );
};

export default CopyFinalMarksModal;
